import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, DialogContent, DialogContentText, IconButton, InputAdornment, Link as MuiLink, TextField, Tooltip } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import DialogAdaptive from '../common/DialogAdaptive';
import StyledCardTitleBar from '../common/StyledCardTitleBar';
import StyledDialogActions from '../common/StyledDialogActions';

interface Props {
    open: boolean;
    postUrl: string;
    onClose: () => void;
}

const InventoryPostSuccessDialog = (props: Props) => {
    const { open, postUrl, onClose } = props;

    const handleCopy = () => {
        navigator.clipboard.writeText(postUrl);
        enqueueSnackbar('Post link copied!', {
            variant: 'success',
            autoHideDuration: 2000,
        });
    };

    return (
        <DialogAdaptive open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <StyledCardTitleBar title="Post Published" />
            <DialogContent>
                <DialogContentText sx={{ mb: 2 }}>Your template variation was posted to OnlyFans.</DialogContentText>
                <TextField
                    fullWidth
                    label="Post link"
                    value={postUrl}
                    InputProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <Tooltip title="Copy post link">
                                    <IconButton edge="end" onClick={handleCopy} aria-label="Copy post link">
                                        <ContentCopyIcon />
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>
                        ),
                    }}
                />
            </DialogContent>
            <StyledDialogActions
                sx={{
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                    px: 3,
                    py: 2,
                }}
            >
                <Button color="secondary" onClick={onClose}>
                    Close
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    component={MuiLink}
                    href={postUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="none"
                    startIcon={<OpenInNewIcon />}
                >
                    Open in new tab
                </Button>
            </StyledDialogActions>
        </DialogAdaptive>
    );
};

export default InventoryPostSuccessDialog;
